import script from "./PDBViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PDBViewer.vue?vue&type=script&setup=true&lang=js"

import "./PDBViewer.vue?vue&type=style&index=0&id=431b472c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-431b472c"]])

export default __exports__